import { Box } from '@chakra-ui/react';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { FieldHelpText, InputVariant } from '@pluxee-design-system/core';
import { useCallback } from 'react';
import { useController } from 'react-hook-form';

interface CaptchaControlProps {
  id: string;
  name: string;
  mandatory?: boolean;
}

const CaptchaControl = ({ id, name, ...captchaProps }: CaptchaControlProps) => {
  const { field, fieldState } = useController({ name });
  const { onChange } = field;
  const { error } = fieldState;
  const handleReset = useCallback(() => onChange(''), [onChange]);
  const handleVerify = useCallback((token: string, _eKey: string) => onChange(token), [onChange]);

  return (
    <Box>
      <HCaptcha
        sitekey={process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY}
        id={id}
        onExpire={handleReset}
        onError={handleReset}
        onChalExpired={handleReset}
        onVerify={handleVerify}
        {...captchaProps}
      />
      {error && <FieldHelpText text={error.message!} variant={InputVariant.ERROR} />}
    </Box>
  );
};

export default CaptchaControl;
